import { render, staticRenderFns } from "./ReportTotal.vue?vue&type=template&id=2eb8cfbf&scoped=true&"
import script from "./ReportTotal.vue?vue&type=script&lang=js&"
export * from "./ReportTotal.vue?vue&type=script&lang=js&"
import style0 from "./ReportTotal.vue?vue&type=style&index=0&id=2eb8cfbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb8cfbf",
  null
  
)

export default component.exports